export function format(first: string, middle: string, last: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

/**
 * Returns boolean information about the existence of a slot in the given element.
 * @param element - The element to check for the slot.
 * @param selector - The slot selector.
 * @returns - A boolean indicating the existence of the slot.
 */
export function hasSlot(element: HTMLElement, selector: string): boolean {
  const slots = element.querySelectorAll(selector);
  let slotsCounter = 0;

  slots.forEach(slot => {
    !!(slot && slot.parentElement.nodeName === element.nodeName) && slotsCounter++;
  });

  return slotsCounter > 0;
}

/**
 * Generates a class names string from an array.
 *
 * @param classNames - An array of class name strings and/or `false` values.
 * @returns A string containing the non-false class names.
 */
export const getClassNames = (classNames: (string | false)[]) => classNames.filter(className => className).join(' ');
